<template>
<div class="time-block"
    :style="blockStyle"
    :class="{
        'past': block.past,
        'disabled': !block || [2,9].indexOf(block.type) > -1,
        'reservation-too-close': [3,4].indexOf(block.type) > -1 && false,
        'reserved': [1,6,7].indexOf(block.type) > -1,
        'reserved-paymentdelayed': block.paymentDelayed && adminMode,
        'reserved-cart': [7].indexOf(block.type) > -1 && adminMode,
        'reserved-partlypaid': block.partlyPaid && adminMode,
        'reserved-userplayerconfirmed': userPlayerConfirmed === true,
        'reserved-allplayersconfirmed': allPlayersConfirmed === true,
        'hidden': block.hide,
    }"
    :title="block.info">
    <div class="timeblock-inner" @click="onClickMaster">
        <div class="title-area">
            <label 
                v-if="isSelectable"
                @click.stop="">
                <span class="title">{{ blockTitle }}</span>
                <input type="checkbox" 
                    v-model="blockChecked" 
                    @click.stop=""
                    @change="$emit('blockChecked', { $event, blockChecked, block })">
            </label>
            <span class="title" v-if="!isSelectable">{{ blockTitle }}</span>
            <div class="time-block-symbols">
                <i class="glyphicon glyphicon-warning-sign" v-if="!!block.paymentDelayed && adminMode"></i>
                <i class="glyphicon glyphicon-comment" 
                    v-if="timeblockComments.length > 0"
                    :title="timeblockComments[0].comment"></i>
            </div>
        </div>
        <div class="timeblock-availbility" 
            @click="onClickAvailibility" 
            :data-content="linkedPlayersHandicap">
            <div class="availability-player slot-reserved slot-disabled"
                v-for="i in disabledSlots" :key="i">
            </div>
            <div class="availability-player slot-available" 
                v-for="index in block.availableQuantity" 
                :key="block.blockId + '-' + index"
                @click="onClickAvailableSlot">
                <span class="available">
                    <i class="glyphicon glyphicon-plus"></i>
                </span>
                <span class="player-name">{{ $_locale('add a player') }}</span>
            </div>
            <div class="availability-player slot-reserved"
                :class="playerClass(player)"
                @click="onClickPlayerSlot(player.personId)"
                v-for="player in linkedPlayers" 
                :key="player.personId">
                <span class="reserved" 
                    :data-content="$_formatCurrency(player.handicapActive, true, 1)">
                </span>
                <span class="player-name" v-if="loggedIn && !!player.namePublic || playerIsUser(player.personId)">{{ player.firstName }} {{ player.familyName }}</span>
                <span class="player-name" v-if="(!loggedIn || !player.namePublic) && !playerIsUser(player.personId)">{{ $_locale('reserved') }}</span>
                <span class="player-club-abbr" v-if="loggedIn && !!player.namePublic || playerIsUser(player.personId)">{{ player.clubAbbreviation }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        block: {
            type: Object,
            required: true,
            default: {},
        },
        enableSelection: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data: () => ({
        blockChecked: false,
    }),
    computed: {
        ...mapGetters({
            loggedIn: 'common/loggedIn',
            VIEW_MODES: 'golf/VIEW_MODES',
            selectedViewMode: 'golf/selectedViewMode',
            userPlayer: 'golf/userPlayer',
            adminMode: 'common/adminMode',
            reservationPlayers: 'golf/reservationPlayers',
            resourceCommentsByBlock: 'reservations/resourceCommentsByBlock',
            settings: 'reservations/settings',
        }),
        blockTitle() {
            const { start } = this.block;

            return start.format('HH:mm');
        },
        playerClass() {
            return (player) => {
                let classes = [];

                if (this.playerIsUser(player.personId)) {
                    classes.push('playerisuser')
                }

                if (player.status === 3) {
                    classes.push('playerconfirmed')
                }

                if (player.paymentDelayed) {
                    classes.push('playerpaymentdelayed')
                }

                if (Array.isArray(player.accessControlClass)) {
                    classes = [
                        ...classes,
                        ...player.accessControlClass
                    ]
                }

                return classes;
            }            
        },
        isSelectable() {
            const longDisabledTimesFilter = (row) => {
                const start = moment(row.start);
                const end = moment(row.end);
                const diff = Math.abs(moment(start).diff(moment(end), 'minutes'));

                return diff <= this.settings.duration;
            }
            if (!this.adminMode) return false;
            if (!this.enableSelection) return false;
            if (!this.block || this.block.reservations.filter(longDisabledTimesFilter).length === 0) return false;

            return true;
        },
        blockStyle() {
            return {
                //height: `calc(var(--time-base-pixel) * ${ block.height })`,
                //top: `calc(var(--time-base-pixel) * ${ block.top })`
            }
        },
        getReservationsQuantity() {
            const reservations = this.block.reservations;

            return reservations.reduce((acc, curr) => acc + curr.quantity, 0)
        },
        userPlayerConfirmed() {
            if (!this.userPlayer.personId) {
                return false;
            }
            
            const personId = this.userPlayer.personId;
            const userPlayer = this.linkedPlayers.filter(row => row.personId === personId)[0];
            
            if (typeof userPlayer === 'undefined') {
                return false;
            }

            return userPlayer.status === 3;
        },
        allPlayersConfirmed() {
            if (this.linkedPlayers.length === 0) {
                return false;
            }
            
            return this.linkedPlayers.length === this.linkedPlayers.filter(row => row.status === 3).length;
        },
        linkedPlayers() {
            if (!Array.isArray(this.block.reservations)) return [];

            const reservations = this.block.reservations.map(
                row => row.reservationTimeId
            );
            
            return this.reservationPlayers.filter(
                row => reservations.indexOf(row.reservationTimeId) > -1
            ).map(row => {
                const reservation = this.block.reservations[reservations.indexOf(row.reservationTimeId)];

                row.paymentDelayed = !!reservation.orderId && reservation.orderStatusId != 2;

                return row;
            }).reverse();
        },
        linkedPlayersHandicap() {
            if (this.linkedPlayers.length === 0) {
                return ' ';
            }

            return this.$_formatCurrency(
                this.linkedPlayers.reduce((acc, curr) => acc + parseFloat(curr.handicapActive), 0),
                true, 
                1
            );
        },
        timeblockComments() {
            return this.resourceCommentsByBlock(this.block);
        },
        disabledSlots() {
            const totalSlots = 4;
            const blockAvailable = this.block.availableQuantity;
            const linkedPlayers = this.linkedPlayers.length;
            const total = totalSlots - (blockAvailable + linkedPlayers);
            
            if (isNaN(total) || total < 0) return 0;

            return total;
        }
    },
    methods: {
        getChecked() {
            return this.blockChecked;
        },
        setChecked(val) {
            this.blockChecked = val;
        },
        onClickMaster() {
            if (this.VIEW_MODES.grid == this.selectedViewMode) {
                this.$emit('click');
            }
        },
        onClickAvailibility() {
            if (this.VIEW_MODES.rows == this.selectedViewMode && this.adminMode) {
                this.$emit('click');
            }
        },
        onClickAvailableSlot() {
            if (this.VIEW_MODES.rows == this.selectedViewMode) {
                this.$emit('click');
            }
        },
        onClickPlayerSlot(personId) {
            if (this.VIEW_MODES.rows == this.selectedViewMode 
                && this.playerIsUser(personId)
                && !this.adminMode) {
                this.$store.commit('common/setModal', 'usergolfreservations')
                this.$store.commit('common/setModalClass', 'modal-lg')
            }
        },
        playerIsUser(personId) {
            if (!this.userPlayer.personId) {
                return false;
            }
            
            return personId === this.userPlayer.personId;
        },
    }
}
</script>